import { render, staticRenderFns } from "./ProjectTradiesList.vue?vue&type=template&id=928b1d10&scoped=true"
import script from "./ProjectTradiesList.vue?vue&type=script&lang=js"
export * from "./ProjectTradiesList.vue?vue&type=script&lang=js"
import style0 from "./ProjectTradiesList.vue?vue&type=style&index=0&id=928b1d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928b1d10",
  null
  
)

export default component.exports